document.addEventListener('DOMContentLoaded', function () {
  function BlackFridayProductLoader() {
    this.currentCollectionHandle = document.querySelector('.bf-nav a').dataset.url;
    this.currentPage = 1;
    this.isLoading = false;
    this.hasMoreProducts = true;
    this.init();
  }

  BlackFridayProductLoader.prototype.init = function () {
    this.bindUI();
    this.loadProducts();
    this.setupIntersectionObserver();
  };

  BlackFridayProductLoader.prototype.bindUI = function () {
    var self = this;
    var links = document.querySelectorAll('.bf-nav a');
    links.forEach(function (link, index) {
      if (index === 0) link.classList.add('active');
      link.addEventListener('click', function (e) {
        self.handleCollectionClick(e, link);
      });
    });

    var loadMoreButton = document.getElementById('load-more-button');
    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', function () {
        if (!self.isLoading) {
          self.loadProducts();
        }
      });
    }
  };

  BlackFridayProductLoader.prototype.handleCollectionClick = function (event, link) {
    event.preventDefault();
    if (this.isLoading || this.currentCollectionHandle === link.dataset.url) return;

    document.querySelectorAll('.bf-nav a').forEach(function (el) {
      el.classList.remove('active');
    });
    link.classList.add('active');

    this.currentCollectionHandle = link.dataset.url;
    this.currentPage = 1;
    this.hasMoreProducts = true;

    var productContainer = document.querySelector('.bf-product-card');
    if (productContainer) {
      productContainer.innerHTML = '';
    }

    var emptyMessage = document.querySelector('.bf-empty-message');
    if (emptyMessage) {
      emptyMessage.remove();
    }

    this.loadProducts();
  };

  BlackFridayProductLoader.prototype.loadProducts = function () {
    var self = this;
    this.isLoading = true;

    var skeletonContainer = document.querySelector('.skeleton-container');
    var loadMoreButton = document.getElementById('load-more-button');
    var productContainer = document.querySelector('.bf-product-card');

    if (skeletonContainer) skeletonContainer.style.display = 'block';
    if (loadMoreButton) loadMoreButton.style.display = 'none';

    fetch('/collections/' + this.currentCollectionHandle + '/products.json?page=' + this.currentPage + '&limit=8')
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data && data.products && data.products.length) {
          var emptyMessage = document.querySelector('.bf-empty-message');
          if (emptyMessage) {
            emptyMessage.remove();
          }

          self.renderProducts(data.products);
          self.currentPage++;
          self.hasMoreProducts = data.products.length === 8;
        } else {
          self.hasMoreProducts = false;

          // Prima pagină fără produse -> mesaj frumos
          if (self.currentPage === 1 && productContainer) {
            productContainer.innerHTML = '' +
              '<div class="bf-empty-message">' +
                '<p>În curs de actualizare.</p>' +
                '<p>Stai aproape, în curând vor apărea și produsele mult așteptate de tine!</p>' +
                '<p>Îți mulțumim pentru înțelegere. ❤️</p>' +
              '</div>';
          }
        }
      })
      .catch(function (error) {
        console.error('Error loading products:', error);
      })
      .finally(function () {
        self.isLoading = false;

        if (skeletonContainer) skeletonContainer.style.display = 'none';

        if (loadMoreButton) {
          loadMoreButton.style.display = self.hasMoreProducts ? 'block' : 'none';
        }
      });
  };

  BlackFridayProductLoader.prototype.renderProducts = function (products) {
    var productContainer = document.querySelector('.bf-product-card');
    var template = document.getElementById('product-template');

    if (!productContainer) {
      console.error('Product container not found');
      return;
    }

    if (!template) {
      console.error('Product template not found');
      return;
    }

    products.forEach(function (product) {
      if (!product || !product.variants || !product.variants.length) {
        console.warn('Product without variants:', product);
        return;
      }

      var productElement = document.importNode(template.content, true);
      var productCard = productElement.querySelector('product-card');

      if (!productCard) {
        console.error('product-card element not found in template');
        return;
      }

      var link = productCard.querySelector('.product-item-url');
      if (link) {
        link.href = '/products/' + product.handle;
      }

      var titleEl = productCard.querySelector('.product-title');
      if (titleEl) {
        titleEl.textContent = product.title;
      }

      // Varianta: prima cu reducere reală, altfel prima
      var variant = product.variants.find(function (v) {
        if (!v || !v.price || !v.compare_at_price) return false;
        var price = parseFloat(v.price);
        var compareAt = parseFloat(v.compare_at_price);
        return !isNaN(price) && !isNaN(compareAt) && compareAt > price;
      }) || product.variants[0];

      if (!variant) {
        console.warn('No valid variant for product:', product);
        return;
      }

      var currentPrice = parseFloat(variant.price);
      if (isNaN(currentPrice)) currentPrice = 0;

      var priceNormalEl = productCard.querySelector('.product-price-normal');
      var priceSaleEl = productCard.querySelector('.product-price-sale');
      var badgeEl = productCard.querySelector('.badge-procent');

      if (priceNormalEl) {
        var currentPriceParts = currentPrice.toFixed(2).split('.');
        priceNormalEl.innerHTML = ''
          + currentPriceParts[0]
          + '<sup><small class="mf-decimal">,</small>' + currentPriceParts[1] + '</sup>'
          + '<span> Lei</span>';
      }

      var comparedAtPrice = variant.compare_at_price ? parseFloat(variant.compare_at_price) : null;

      if (comparedAtPrice && !isNaN(comparedAtPrice) && comparedAtPrice > currentPrice) {
        var discountPercentage = Math.round(((comparedAtPrice - currentPrice) / comparedAtPrice) * 100);

        if (badgeEl) {
          badgeEl.textContent = '-' + discountPercentage + '%';
          badgeEl.style.display = 'block';
        }

        if (priceSaleEl) {
          var comparedAtPriceParts = comparedAtPrice.toFixed(2).split('.');
          priceSaleEl.innerHTML = ''
            + '<s>' + comparedAtPriceParts[0]
            + '<sup><small class="mf-decimal">,</small>' + comparedAtPriceParts[1] + '</sup>'
            + '<span> Lei</span></s>';
          priceSaleEl.style.display = 'block';
        }
      } else {
        if (priceSaleEl) priceSaleEl.style.display = 'none';
        if (badgeEl) badgeEl.style.display = 'none';
      }

      var imageWrapper = productCard.querySelector('.product-item_img');
      var imageEl = productCard.querySelector('.product-image');
      if (imageEl) {
        if (product.images && product.images[0]) {
          imageEl.src = product.images[0].src;
          imageEl.alt = product.title;
        } else {
          imageEl.src = '';
          imageEl.alt = product.title || '';
        }
      }

      // 🔹 Badge & clasă stoc
      var isInStock = product.variants.some(function (v) {
        return v && v.available;
      });

      if (isInStock) {
        productCard.classList.add('inStock');
        productCard.classList.add(discountPercentage);
      } else {
        productCard.classList.add('outOfStock');

        if (imageWrapper) {
          var existingBadge = imageWrapper.querySelector('.badge-stock');
          if (!existingBadge) {
            var badgeStock = document.createElement('div');
            badgeStock.className = 'badge-stock';
            badgeStock.textContent = 'Stoc epuizat';
            imageWrapper.appendChild(badgeStock);
          }
        }
      }

      productContainer.appendChild(productElement);
    });
  };

  BlackFridayProductLoader.prototype.setupIntersectionObserver = function () {
    var self = this;
    var loadMoreButton = document.getElementById('load-more-button');

    if (!loadMoreButton || typeof IntersectionObserver === 'undefined') {
      return;
    }

    var observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    };

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !self.isLoading && self.hasMoreProducts) {
          self.loadProducts();
        }
      });
    }, observerOptions);

    observer.observe(loadMoreButton);
  };

  function ProductCard() {
    HTMLElement.call(this);
  }

  ProductCard.prototype = Object.create(HTMLElement.prototype);
  ProductCard.prototype.constructor = ProductCard;

  customElements.define('product-card', ProductCard);

  new BlackFridayProductLoader();
});
